export default __webpack_public_path__ + "static/media/06.43051ff2.jpg";